import React, { useEffect, useState } from 'react';
import { Grid, Typography, Button, IconButton, Stack, Box } from '@mui/material';
import { Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { FieldCreator } from '../configured-inputs/form-creator/FormCreator';
import _ from 'lodash';

function Array({ fieldCreatorProps, minimum, addLabel, defaultValues, label, labelProps, fieldName, minWidth = undefined, ...rest }) {
    const { control } = useFormContext();
    const { fields, remove, append } = useFieldArray({ control, name: fieldName });
    const [form, setForm] = useState([]);

    useEffect(() => {
        if (minimum) {
            // HACK: This is a hack to ensure that the minimum number of fields are displayed
            //       Using Array(minimum).fill({}) causes react to error with invalid hook call
            const items = [];
            for (let i = 0; i < minimum; i++) {
                items.push({});
            }
            append(items);
        }
    }, []);

    useEffect(() => {
        const sectionForm = _.pick(fieldCreatorProps.form, fieldCreatorProps.fields);

        setForm(
            fields.map((_field, idx) => {
                const updatedForm = _.cloneDeep(sectionForm);

                Object.keys(updatedForm).forEach((key) => {
                    updatedForm[key].name = `${fieldName}.${idx}.${updatedForm[key].name}`;

                    if (updatedForm[key].conditionalRender?.referenceArrayFields) {
                        updatedForm[key].conditionalRender.referenceArrayFields = updatedForm[key].conditionalRender.referenceArrayFields.map((field) => `${fieldName}.${idx}.${field}`);
                    }
                });

                return updatedForm;
            })
        );
    }, [fields]);

    return (
        <Stack spacing={2} marginBottom={4} sx={{ minWidth }}>
            {label && (
                <Typography sx={{ marginY: '16px' }} variant="h5" {...labelProps}>
                    {label}
                </Typography>
            )}

            {fields.map((field, idx) => (
                <Stack direction="row" spacing={2} key={field.id} alignItems="center">
                    <Grid container spacing={1} alignItems="center" sx={{ border: '2px solid rgba(0, 0, 0, 0.12)', paddingRight: 1, marginLeft: 0 }} borderRadius={1} {...rest}>
                        <FieldCreator key={field.id} {...fieldCreatorProps} form={form[idx] ?? {}} />
                    </Grid>
                    <Box>
                        <IconButton key={field.id} aria-label="remove" variant="outlined" color="error" disabled={minimum && fields.length <= minimum} onClick={() => remove(idx)}>
                            <DeleteIcon />
                        </IconButton>
                    </Box>
                </Stack>
            ))}

            <Box>
                <Button aria-label="add" startIcon={<AddIcon />} variant="outlined" onClick={() => append({})}>
                    {addLabel || 'Add'}
                </Button>
            </Box>
        </Stack>
    );
}

export default Array;
